export const fonts = {
    'light': '#fffffd',
    'faded': '#909690',
    'red': '#c73c30',
    'purple': '#8872a2',
    'green': '#8aa83a',
    'blue': '#6089a6',
    'organge': '#ce6710',
    'yellow': '#cbcb37'
}

export const backgrounds = {
    'dark': '#1e1e1e',
    'light': '#282828',
    'lightest': '#404040'
}